import Model from '@/models/Model.js';

export default class LtiContext extends Model {
    static entity = 'lti_contexts';

    static fields() {
        return {
            id: this.attr(null),

            ...super.fields(),
        };
    }
}
